module.exports = __webpack_public_path__ + "6d355c3446272b59424cb637913fe55a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OurTeam/dominika-krupkova.jpg
// module id = 570
// module chunks = 0